import { useState } from 'react';

export const useSuggestions = (items, extractValue = item => item) => {
	const [suggestions, setSuggestions] = useState([]);
	const [showSuggestions, setShowSuggestions] = useState(false);

	const updateSuggestions = (inputValue) => {
		const searchTerm = inputValue.toLowerCase().trim();
		const normalizeValue = (value) => String(value ?? "");
		const filteredItems = items.filter((item) =>
			normalizeValue(extractValue(item)).toLowerCase().includes(searchTerm)
		);

		const updated = [inputValue, ...filteredItems.map((item) => normalizeValue(extractValue(item)))];

		setSuggestions(updated);
		setShowSuggestions(searchTerm.length > 0 && filteredItems.length > 0);
	};

	const hideSuggestions = () => setShowSuggestions(false);

	return {
		suggestions,
		showSuggestions,
		updateSuggestions,
		hideSuggestions,
		setShowSuggestions
	};
};
